export const FILTER_ICON_SIZE = 20;

export const BUTTON_SEARCH_TEXT = 'Search';
